/* lua.js generated code 0.3.0 */

/* 
Copyright (c) 2011-2015 chukong-incc.com

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

 */
if (type(DEBUG) !== "number") {
    DEBUG = 0
}
// load framework
if (DEBUG) {
    printInfo("")
    printInfo("# DEBUG                        = " + DEBUG)
    printInfo("#")
}

// device = require("cocos/framework/device")
filter = require("cocos/framework/filter")
display = require("cocos/framework/display")
// not used
// audio = require("cocos/framework/audio")
// transition = require("cocos/framework/transition")
require("cocos/framework/extends/NodeEx")
require("cocos/framework/extends/SpriteEx")
require("cocos/framework/extends/LayerEx")
// require("cocos/framework/extends/MenuEx")
require("cocos/framework/extends/DirectorEx")
if (ccui) {
    require("cocos/framework/extends/UIWidget")
    require("cocos/framework/extends/UICheckBox")
    require("cocos/framework/extends/UIEditBox")
    require("cocos/framework/extends/UIListView")
    require("cocos/framework/extends/UIPageView")
    require("cocos/framework/extends/UIScrollView")
    require("cocos/framework/extends/UISlider")
    require("cocos/framework/extends/UITextField")
    require("cocos/framework/extends/UIButtonEx")
}
// require("cocos/framework/package_support")
// cc.register("event", require("cocos/framework/components/event"))
// FIXME: 
// var __g = _G
// cc.exports = table()
// setmetatable(cc.exports, table([1, "__newindex", function (_, name, value) {
//         rawset(__g, name, value)
//     }], [1, "__index", function (_, name) {
//         // WARN: maybe multi result
//         return rawget(__g, name)
//     }]))
// cc.disable_global = function () {
//     setmetatable(__g, table([1, "__newindex", function (_, name, value) {
//             error(string.format("USE \" cc.exports.%s = value \" INSTEAD OF SET GLOBAL VARIABLE", name), 0)
//         }]))
// }
// if (CC_DISABLE_GLOBAL) {
//     cc.disable_global()
// }
